import React, { Fragment } from 'react'

export function CompanyDetailsAr() {
  return (
    <Fragment>
      <div className="company-details-field">
        <span className="company-details-field__label">الاسم القانوني</span>
        <span className="company-details-field__text">Darpo Vision FZ LLC</span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">الاسم التجاري</span>
        <span className="company-details-field__text">VIORY</span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">العنوان</span>
        <span className="company-details-field__text">
          مجمع ياس للإبداع، البرج الثاني، ياس جنوب 769931، أبو ظبي، الإمارات
          العربية المتحدة
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">صندوق بريد</span>
        <span className="company-details-field__text">
          769931، أبو ظبي، الإمارات العربية المتحدة
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">الرخصة التجارية</span>
        <span className="company-details-field__text">B.L. 1252/23</span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">خدمة العملاء</span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:cs@viory.video">cs@viory.video</a>
          </span>
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">
          قدم قصتك على البريد الالكتروني
        </span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:sendvideo@viory.video">sendvideo@viory.video</a>
          </span>
        </span>
      </div>
      <div className="company-details-field">
        <span className="company-details-field__label">للتواصل الإعلامي</span>
        <span className="company-details-field__text">
          <span className="company-details__mail">
            <a href="mailto:pr@viory.video">pr@viory.video</a>
          </span>
        </span>
      </div>
      <div className="company-details-field company-details-field--padded">
        <span className="company-details-field__label">إخلاء المسؤولية</span>
        <span className="company-details-field__text company-details-field__text--padded">
          قد يحتوي موقعنا الالكتروني في بعض الأحيان على روابط لمواقع ومصادر أخرى
          (روابط خارجية)، لا نتحمل أية مسؤولية كانت, ضمناً المسؤولية القانونية,
          نتيجة استخدام أي مواقع الكترونية خارجية مدرجة أو أي من محتوياتها. نوصي
          بضرورة مراجعة شروط الاستخدام وبيانات الخصوصية الخاصة بهذه المواقع
          الخارجية قبل استخدامها.
        </span>
      </div>
    </Fragment>
  )
}

export const CompanyDetailsMapAr = () => (
  <div className="company-details-block__map-container">
    <iframe
      className="company-details-block__map"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1815.8418544206074!2d54.5998516!3d24.4617566!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e45eef5646855%3A0x8c31ff8520a7f72b!2sYas%20Creative%20Hub!5e0!3m2!1sar!2sru!4v1692953315316!5m2!1sar!2sru"
      width="600"
      height="450"
      style={{ border: 0 }}
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
)
